var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDzen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00397 13.7303C5.00133 13.8199 5 13.9097 5 14C5 14.0902 5.00133 14.1801 5.00397 14.2697C8.64997 14.3152 10.6996 14.5646 12.0675 15.9325C13.4354 17.3004 13.6848 19.35 13.7303 22.996C13.8199 22.9987 13.9098 23 14 23C14.0902 23 14.1801 22.9987 14.2697 22.996C14.3152 19.35 14.5646 17.3004 15.9325 15.9325C17.3004 14.5646 19.35 14.3152 22.996 14.2697C22.9987 14.1801 23 14.0902 23 14C23 13.9097 22.9987 13.8199 22.996 13.7303C19.35 13.6848 17.3004 13.4354 15.9325 12.0675C14.5646 10.6996 14.3152 8.64996 14.2697 5.00397C14.1801 5.00133 14.0902 5 14 5C13.9098 5 13.8199 5.00133 13.7303 5.00397C13.6848 8.64996 13.4354 10.6996 12.0675 12.0675C10.6996 13.4354 8.64996 13.6848 5.00397 13.7303Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDzen);
export default __webpack_public_path__ + "static/media/dzen.c4a3fb5ee05c10c814d6c0d83bbc3233.svg";
export { ForwardRef as ReactComponent };